/* eslint-disable @typescript-eslint/naming-convention */
import type { FC, PropsWithChildren } from 'react';

import type { PostHogPersistence } from '@models/postHog';
import { PostHogProvider as VendorProvider } from 'posthog-js/react';

const PostHogProvider: FC<PropsWithChildren> = ({ children }) => {
  const { VITE_PUBLIC_POSTHOG_KEY, VITE_PUBLIC_POSTHOG_HOST } = import.meta.env;

  const postHogConfig = {
    apiKey: VITE_PUBLIC_POSTHOG_KEY,
    options: {
      api_host: VITE_PUBLIC_POSTHOG_HOST,
      capture_pageview: true,
      persistence: 'localStorage' as PostHogPersistence
    }
  };

  return <VendorProvider {...postHogConfig}>{children}</VendorProvider>;
};

export default PostHogProvider;
